import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider, useApp } from "@/context/AppContext";
import { AppShell } from "@/components/shell/AppShell";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Brochure from "@/pages/Brochure";
import Login from "@/pages/Login";
import SuperAdminLogin from "@/pages/SuperAdminLogin";
import Desktop from "@/pages/Desktop";
import Cockpit from "@/pages/admin/Cockpit";
import Risk from "@/pages/admin/Risk";
import CostLedger from "@/pages/admin/CostLedger";
import UsageValue from "@/pages/admin/UsageValue";
import Gateway from "@/pages/admin/Gateway";
import Policies from "@/pages/admin/Policies";
import AppsInventory from "@/pages/admin/AppsInventory";
import IntegrationHub from "@/pages/admin/IntegrationHub";
import Evidence from "@/pages/admin/Evidence";
import Access from "@/pages/admin/Access";
import People from "@/pages/admin/People";
import HelpGuides from "@/pages/admin/HelpGuides";
import SuperAdmin from "@/pages/admin/SuperAdmin";
import CompanionHome from "@/pages/companion/Home";
import MyTools from "@/pages/companion/MyTools";
import PromptStudio from "@/pages/companion/PromptStudio";
import Advisor from "@/pages/companion/Advisor";
import MyActivity from "@/pages/companion/MyActivity";
import PolicyPlain from "@/pages/companion/PolicyPlain";
import Requests from "@/pages/companion/Requests";
import Learn from "@/pages/companion/Learn";

const RequireAuth = ({ children }) => {
  const { user } = useApp();
  let stored = null;
  try { stored = JSON.parse(localStorage.getItem("navitra-user") || "null"); } catch (e) { stored = null; }
  if (!user && !stored) return <Navigate to="/login" replace />;
  return children;
};

const Shell = (C) => (
  <RequireAuth><AppShell><C /></AppShell></RequireAuth>
);

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/brochure" element={<Brochure />} />
          <Route path="/login" element={<Login />} />
          <Route path="/_admin" element={<SuperAdminLogin />} />
          <Route path="/os" element={<RequireAuth><Desktop /></RequireAuth>} />
          <Route path="/admin" element={<Navigate to="/admin/cockpit" replace />} />
          <Route path="/admin/cockpit" element={Shell(Cockpit)} />
          <Route path="/admin/risk" element={Shell(Risk)} />
          <Route path="/admin/ledger" element={Shell(CostLedger)} />
          <Route path="/admin/usage" element={Shell(UsageValue)} />
          <Route path="/admin/gateway" element={Shell(Gateway)} />
          <Route path="/admin/policies" element={Shell(Policies)} />
          <Route path="/admin/apps" element={Shell(AppsInventory)} />
          <Route path="/admin/hub" element={Shell(IntegrationHub)} />
          <Route path="/admin/evidence" element={Shell(Evidence)} />
          <Route path="/admin/access" element={Shell(Access)} />
          <Route path="/admin/people" element={Shell(People)} />
          <Route path="/admin/help" element={Shell(HelpGuides)} />
          <Route path="/admin/super" element={Shell(SuperAdmin)} />
          <Route path="/companion" element={<Navigate to="/companion/home" replace />} />
          <Route path="/companion/home" element={Shell(CompanionHome)} />
          <Route path="/companion/tools" element={Shell(MyTools)} />
          <Route path="/companion/prompt-studio" element={Shell(PromptStudio)} />
          <Route path="/companion/advisor" element={Shell(Advisor)} />
          <Route path="/companion/activity" element={Shell(MyActivity)} />
          <Route path="/companion/policy" element={Shell(PolicyPlain)} />
          <Route path="/companion/requests" element={Shell(Requests)} />
          <Route path="/companion/learn" element={Shell(Learn)} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
